import styled from 'styled-components';
import { IconButton } from '@web-chat-core/ui-kit';

export const BannerContainer = styled.div`
    position: absolute;
    top: 28px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 15;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 484px;
    max-width: min(92vw, 484px);
    padding: 10px 12px;
    border-radius: 16px;
    background: ${(props) => props.theme.root.colors.background.sheetOrModal};
    border: 1px solid ${(props) => props.theme.root.colors.background.badgeMuted};

    @media (max-width: 700px) {
        min-width: 0;
        width: calc(100vw - 20px);
        max-width: none;
        gap: 8px;
    }
`;

export const BannerLead = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const BannerText = styled.div`
    letter-spacing: 0.25px;
    min-width: 0;
`;

export const BannerTitle = styled.div`
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const BannerDescription = styled.div`
    white-space: nowrap;
    color: ${(props) => props.theme.root.colors.basicColors['55%']};
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
`;

export const BannerActions = styled.div`
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    gap: 6px;
    margin-left: auto;
    flex-shrink: 0;
`;

export const BannerPrimaryAction = styled.button`
    border: none;
    border-radius: 20px;
    padding: 7px 16px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.accent.textOrIcon};
    background: transparent;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.1px;
    font-weight: 500;

    &:hover:not(:disabled) {
        background: ${(props) => props.theme.root.colors.basicColors['6%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const BannerSecondaryAction = styled.button`
    border: none;
    border-radius: 20px;
    padding: 7px 16px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    background-color: transparent;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.1px;
    font-weight: 500;

    &:hover:not(:disabled) {
        background: ${(props) => props.theme.root.colors.basicColors['6%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const BannerApproveButton = styled.button`
    border: none;
    border-radius: 16px;
    padding: 6px 10px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.accent.textOrIcon};
    background: transparent;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;

    &:hover:not(:disabled) {
        background: ${(props) => props.theme.root.colors.basicColors['6%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const BannerRejectButton = styled.button`
    border: none;
    border-radius: 16px;
    padding: 6px 10px;
    cursor: pointer;
    color: #fff;
    background: transparent;
    font-size: 14px;
    font-weight: 500;

    &:hover:not(:disabled) {
        background: ${(props) => props.theme.root.colors.basicColors['6%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const BannerClose = styled(IconButton)`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        fill: ${(props) => props.theme.root.colors.basicColors['55%']};
    }
`;
